module.exports = __webpack_public_path__ + "img/tool_bg_model.4479bfe9.svg";